import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import "./Product.scss";

import Header from "../../inc/Header";
import Footer from "../../inc/Footer";
import BottomToTop from "../../inc/BottomToTop";
import PageContent from "./PageContent";
import MedicalGrade from "./MedicalGrade";
import ProductView from "./ProductView";
import Technical from "./Technical";
import OrderNow from "../../inc/OrderNow";

import { Helmet } from "react-helmet";
import seoMeta from "../../../../assets/SEO/seoMeta.json";
import SignUpForTrial from "../../inc/SignUpForTrial";
const seo = seoMeta.product;
class ProductA5 extends Component {
  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();
    this.resizeTimer = null;
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("orientationchange", this.handleOrientationChange);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener(
      "orientationchange",
      this.handleOrientationChange
    );
    clearTimeout(this.resizeTimer);
  }

  handleResize = () => {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      const iframe = this.iframeRef.current;
      if (iframe) {
        const src = iframe.src;
        iframe.src = "";
        setTimeout(() => {
          iframe.src = src;
        }, 100);
      }
    }, 300);
  };

  handleOrientationChange = () => {
    setTimeout(this.handleResize, 500);
  };

  render() {
    return (
      <>
        <Helmet>
          <title>{seo.title}</title>
          <meta name="description" content={seo.description} />
          <meta name="keywords" content={seo.keywords} />

          {/* OG Tags */}
          <meta property="og:title" content={seo.og.title} />
          <meta property="og:description" content={seo.og.description} />
          <meta property="og:image" content={seo.og.image} />
          <meta property="og:url" content={seo.og.url} />
          <meta property="og:site_name" content={seo.og.site_name} />
          <meta property="og:type" content={seo.og.type} />
          <meta property="og:locale" content={seo.og.locale} />

          {/* Meta tags khác */}
          <meta name="RATING" content={seo.meta.rating} />
          <meta name="robots" content={seo.meta.robots} />
          <meta name="copyright" content={seo.meta.copyright} />
          <meta name="author" content={seo.meta.author} />
          <meta name="audience" content={seo.meta.audience} />
          <meta name="resource-type" content={seo.meta.resource_type} />
          <meta name="distribution" content={seo.meta.distribution} />
          <meta name="revisit-after" content={seo.meta.revisit_after} />
          <meta name="GENERATOR" content={seo.meta.generator} />

          {/* Link tags */}
          <link rel="canonical" href={seo.canonical} />
          <link rel="alternate" href={seo.hreflang.vi} hreflang="vi" />
          {/* <link rel="shortcut icon" href={seo.favicon} type="image/x-icon" />
          <link rel="apple-touch-icon" href={seo.favicon} />
          <link rel="apple-touch-icon-precomposed" href={seo.favicon} /> */}

          {/* JSON-LD Schema */}
          <script type="application/ld+json">
            {JSON.stringify(seo.jsonld)}
          </script>
        </Helmet>
        <Header />
        <PageContent />
        <div className="container">
          <MedicalGrade />
          <ProductView />
          <Technical />
        </div>
        <Footer />
        <BottomToTop />
        <OrderNow />
        {/* <SignUpForTrial /> */}
      </>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductA5)
);
